module.exports = __webpack_public_path__ + "static/mockapp-talk-report-d0084ff044466b16f9e2df819df413b3.png";